export default ({ xAxisFormatter }: FixmeType) => {
    return {
        xAxis: {
            labels: {
                formatter: function () {
                    return xAxisFormatter(this);
                },
            },
        },
    };
};
